import React from 'react'

export default function Alert(props) {
    function capitalizeText(text) {
        return text
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
      }
    return (
        <div className="">
            {props.alert && <div className={`alert alert-${props.alert.Type} alert-dismissible fade show`} role="alert">
                <strong> {capitalizeText(props.alert.Type)}.</strong> {props.alert.msg}
                <button type="button" className="btn-close" onClick={() => { props.setAlert(null) }}></button>
            </div>}
        </div>
    )
}
